import React, { useState } from 'react';
import useTopPosts from './useTopPosts';
import styles from './TopPosts.module.css';
import Skeleton from '../../../../../../ui/Skeleton/Skeleton';
import SearchInput from '../../../../../../ui/DataEntry/SearchInput/SearchInput';
import TopPostsTable from './TopPostsTable';
import { numberWithCommas } from '../../../../../../helpers';

type TopPostsProps = {
    clientId: number;
    songId: number;
};

const TopPosts = ({ songId, clientId }: TopPostsProps) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');

    const { count, hasErrorLoading, isLoading, stats, reset } = useTopPosts({
        clientId,
        songId,
        search,
        page,
        page_size: pageSize,
        ordering: '-play_count',
    });

    const [tiktokTopPostsRowsDisplayed, setTiktokTopPostsRowsDisplayed] = useState(0);
    const topPostsRecordsShowingLabel = `displaying ${tiktokTopPostsRowsDisplayed} post${
        tiktokTopPostsRowsDisplayed === 1 ? '' : 's'
    } out of ${numberWithCommas(count)} analysed`;

    return (
        <>
            <div className={styles.titles}>
                <p className={styles.title}>Top Posts</p>
                <p className={styles.subtitle}>
                    {isLoading ? <Skeleton width="20rem" /> : topPostsRecordsShowingLabel}
                </p>
            </div>
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <SearchInput
                        value={search}
                        onChange={(search) => {
                            reset();
                            setSearch(search);
                        }}
                    />
                </div>
            </div>
            <TopPostsTable
                loading={isLoading}
                data={stats}
                count={count}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={(value) => setPageSize(value ?? 10)}
                onPaginationChange={(state) => setTiktokTopPostsRowsDisplayed(state.pageRows.length)}
                noDataLabel={hasErrorLoading ? 'Sorry, technical issues occurred' : 'No data'}
            />
        </>
    );
};

export default TopPosts;
